'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StrongPassword = function () {
  function StrongPassword() {
    'ngInject';

    _classCallCheck(this, StrongPassword);

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  _createClass(StrongPassword, [{
    key: 'link',
    value: function link($scope, element, attrs, ctrl) {
      ctrl.$validators.strongPassword = function (modelValue) {
        // check if contains uppercase
        if (!/[A-Z]/.test(modelValue)) {
          return false;
        }

        // check if contains lowercase
        if (!/[a-z]/.test(modelValue)) {
          return false;
        }

        // check if contains number
        if (!/[0-9]/.test(modelValue)) {
          return false;
        }

        if (modelValue.length < 8) {
          return false;
        }

        return true;
      };
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory() {
      'ngInject';

      return new StrongPassword();
    }
  }]);

  return StrongPassword;
}();

exports.default = StrongPassword;


// WEBPACK FOOTER //
// ./common/directives/validation/strong-password.js